import { ActionList, Container, Divider } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { AboutCertn } from "./AboutCertn";
import { DisputeReportResults } from "./DisputeReportResults";
import { GeneralFeedback } from "./GeneralFeedback";
import { HelpCenterButton } from "./HelpCenterButton";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { ReferAndEarnTeaser } from "./ReferAndEarn";
import { ReportAProblem } from "./ReportAProblem";
import { TermsOfUse } from "./TermsOfUse";
import { TitleBar } from "./TitleBar";
import { RequestPersonalData } from "./request-personal-data/RequestPersonalData";
import { AppTitle } from "../../../components/AppTitle";
import { useDocumentTitle } from "../../../hooks/api/useDocumentTitle";

export function HelpPrivacyPage() {
  const { t } = useTranslation();
  useDocumentTitle(t("Help & Privacy — Certn"));

  return (
    <Container>
      <TitleBar>
        <AppTitle title={t("Help & privacy")} />
        <HelpCenterButton />
      </TitleBar>
      <ReferAndEarnTeaser />
      <ActionList ariaLabel={t("Help & privacy")}>
        <ReportAProblem />
        <Divider />
        <GeneralFeedback />
        <Divider />
        <AboutCertn />
        <Divider />
        <PrivacyPolicy />
        <Divider />
        <TermsOfUse />
        <Divider />
        <DisputeReportResults />
        <Divider />
        <RequestPersonalData />
      </ActionList>
    </Container>
  );
}
